var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDarkOrbit2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 478 476"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.016%",
    y1: "7.035%",
    x2: "24.998%",
    y2: "92.944%",
    id: "dark-orbit-2_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#646A7E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1932",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.016%",
    y1: "7.035%",
    x2: "24.998%",
    y2: "92.944%",
    id: "dark-orbit-2_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#646A7E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1932",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#7C8E9B",
    strokeWidth: 0.541,
    cx: 237.883,
    cy: 236.883,
    rx: 237.883,
    ry: 236.883
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#dark-orbit-2_svg__a)",
    fillRule: "nonzero",
    opacity: 0.4,
    cx: 238.156,
    cy: 237.155,
    rx: 185.172,
    ry: 184.394
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#dark-orbit-2_svg__b)",
    fillRule: "nonzero",
    opacity: 0.4,
    cx: 235.971,
    cy: 234.98,
    rx: 146.936,
    ry: 146.318
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#7C8E9B",
    strokeWidth: 0.541,
    cx: 238.156,
    cy: 237.155,
    rx: 185.172,
    ry: 184.394
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5F6B7C",
    fillRule: "nonzero",
    cx: 89.035,
    cy: 52.762,
    rx: 3.277,
    ry: 3.264
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5F6B7C",
    fillRule: "nonzero",
    cx: 241.433,
    cy: 52.762,
    rx: 3.277,
    ry: 3.264
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5F6B7C",
    fillRule: "nonzero",
    cx: 369.251,
    cy: 368.244,
    rx: 3.277,
    ry: 3.264
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5F6B7C",
    fillRule: "nonzero",
    cx: 377.718,
    cy: 45.419,
    rx: 5.189,
    ry: 5.167
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5F6B7C",
    fillRule: "nonzero",
    cx: 54.896,
    cy: 214.582,
    rx: 4.643,
    ry: 4.623
  }))));
}

export default "data:image/svg+xml;base64,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";
export { SvgDarkOrbit2 as ReactComponent };